module.exports = __webpack_public_path__ + "img/combanner.ae1e7580.png";